import { Grid, Typography } from "@material-ui/core";
import { LifetimeIncomeCard, MentorTip } from "../../../components";
import { Navigation } from "../../../models/navigation";
import { Header } from "../../../shared/components/header";
import { toolstyles } from "./tools.styles";

interface MentorContainerProps {
  navigation: Navigation[];
}

export const Tools = ({ navigation }: MentorContainerProps) => {
  const classes = toolstyles();

  return (
    <Header navigation={navigation}>
      <Grid container>
        <Grid item xs={12}>
          <Typography component="h1" className={classes.title}>
            Tools
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <MentorTip
            className={classes.mentorTip}
            title={
              <Typography className="mentorTitle">
                <b>Tools</b> help you understand your financial picture. Check
                back periodically as we keep adding more!
              </Typography>
            }
          />
        </Grid>
        <Grid container>
          <Grid item xs={6} className={classes.card} />
          <Grid item xs={6} className={classes.card}>
            <LifetimeIncomeCard />
          </Grid>
        </Grid>
      </Grid>
    </Header>
  );
};
